import SidebarContext from 'state/SidebarContext';
import { IconTriangle24 as TriangleIcon } from '@fabric-ds/icons/react';
import { useContext } from 'react';
import pulseClient from 'resources/pulse';

const SuggestFailed = () => {
    const { finnkode } = useContext(SidebarContext);

    pulseClient.trackViewSuggestShippingFailed(finnkode);
    return (
        <>
            <TriangleIcon />
            <p className="font-bold mt-16 ">Her har det skjedd noe galt!</p>
            <p>
                Vi fikk ikke sagt til selger at du vil bruke Fiks ferdig. Du kan sende melding og
                bruke gamlemåten.
            </p>
            <finn-contact-button></finn-contact-button>
        </>
    );
};

export default SuggestFailed;
